import { useState } from 'react'
import { Link } from 'react-router-dom'
import logo from '../assets/groupeouambologo.jpg'
import './Header.css'

function Header({ t, lang, setLang }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [servicesOpen, setServicesOpen] = useState(false)

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
    if (!mobileMenuOpen) {
      setServicesOpen(false)
    }
  }

  const closeMobileMenu = () => {
    setMobileMenuOpen(false)
    setServicesOpen(false)
  }

  return (
    <header className="site-header">
      {/* Brand - Always visible on desktop */}
      <Link className="brand" to="/">
        <img className="brand-logo" src={logo} alt="Groupe Ouambo logo" />
        <div className="brand-text">
          <span className="brand-name">{t.brand}</span>
        </div>
      </Link>

      {/* Mobile Menu Button */}
      <button
        className={`mobile-menu-btn ${mobileMenuOpen ? 'open' : ''}`}
        onClick={toggleMobileMenu}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Navigation - Desktop & Mobile */}
      <nav className={`nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        <Link to="/#home" onClick={closeMobileMenu}>{t.nav.home}</Link>
        <Link to="/about" onClick={closeMobileMenu}>{t.nav.about}</Link>

        <div className="nav-dropdown">
          <button
            className="nav-dropdown-trigger"
            onClick={() => setServicesOpen(!servicesOpen)}
          >
            {t.nav.services}
            <span className={`dropdown-arrow ${servicesOpen ? 'open' : ''}`}>▼</span>
          </button>
          <div className={`nav-dropdown-menu ${servicesOpen ? 'mobile-open' : ''}`}>
            <Link to="/technology" onClick={closeMobileMenu}>{t.nav.technology}</Link>
            <Link to="/technology#platforms" onClick={closeMobileMenu}>{t.nav.platforms}</Link>
            <Link to="/technology#energy" onClick={closeMobileMenu}>{t.nav.energy}</Link>
            <Link to="/transport" onClick={closeMobileMenu}>{t.nav.transport}</Link>
            <Link to="/investment" onClick={closeMobileMenu}>{t.nav.investment}</Link>
          </div>
        </div>

        <Link to="/contact" onClick={closeMobileMenu}>{t.nav.contact}</Link>
        <Link to="/careers" onClick={closeMobileMenu}>{t.nav.careers}</Link>

        {/* Mobile-only actions */}
        <div className="mobile-nav-actions">
          <div className="lang-toggle">
            <button
              type="button"
              className={lang === 'en' ? 'active' : ''}
              onClick={() => setLang('en')}
              aria-pressed={lang === 'en'}
            >
              EN
            </button>
            <button
              type="button"
              className={lang === 'fr' ? 'active' : ''}
              onClick={() => setLang('fr')}
              aria-pressed={lang === 'fr'}
            >
              FR
            </button>
          </div>
          <Link className="btn primary" to="/contact" onClick={closeMobileMenu}>
            {t.nav.cta}
          </Link>
        </div>
      </nav>

      {/* Desktop Actions */}
      <div className="header-actions desktop-only">
        <div className="lang-toggle">
          <button
            type="button"
            className={lang === 'en' ? 'active' : ''}
            onClick={() => setLang('en')}
            aria-pressed={lang === 'en'}
          >
            EN
          </button>
          <button
            type="button"
            className={lang === 'fr' ? 'active' : ''}
            onClick={() => setLang('fr')}
            aria-pressed={lang === 'fr'}
          >
            FR
          </button>
        </div>
        <Link className="btn primary" to="/contact">
          {t.nav.cta}
        </Link>
      </div>
    </header>
  )
}

export default Header
